/* eslint-disable camelcase */
import type { Creative, PlacementRawResponse } from './queries/usePlacementRaw';

// eslint-disable-next-line @typescript-eslint/ban-types
export const getCreativesFromPlacementRaw = <T = {}>(
  data: PlacementRawResponse<T> | null | undefined,
): Creative<T>[] => {
  if (!data) return [];
  return data.placements.flatMap((placement) => placement.creatives);
};
